import React from 'react';
import { ArrowRight } from 'lucide-react';
import { Button } from './ui/button';

const CTA = () => {
  return (
    <section className="relative overflow-hidden bg-gradient-to-r from-blue-700 to-cyan-600 py-20">
      <div className="absolute -top-20 -right-16 w-72 h-72 bg-white/10 rounded-full blur-3xl animate-float" />
      <div className="absolute -bottom-24 -left-10 w-80 h-80 bg-cyan-300/10 rounded-full blur-3xl" />
      <div className="relative max-w-4xl mx-auto px-5 text-center">
        <h2 className="font-heading font-bold text-white text-3xl md:text-4xl">Ready to Get Started?</h2>
        <p className="mt-4 text-blue-50 text-lg max-w-2xl mx-auto">
          Join thousands of satisfied customers who trust Xpert Consultant for their technical needs.
        </p>
        <div className="mt-9 flex flex-col sm:flex-row items-center justify-center gap-4">
          <Button asChild size="lg" className="bg-white text-blue-700 hover:bg-blue-50 font-semibold rounded-lg px-7 h-12">
            <a href="#contact">Contact Us Now <ArrowRight size={18} className="ml-1" /></a>
          </Button>
          <Button asChild size="lg" variant="outline" className="border-white/50 bg-transparent text-white hover:bg-white/15 hover:text-white rounded-lg px-7 h-12">
            <a href="#pricing">Browse Plans</a>
          </Button>
        </div>
      </div>
    </section>
  );
};

export default CTA;
